import { fetcher } from "@/services/api/fetcher";
import { useQuery } from "@tanstack/react-query";
import {
  AlsintanByCategoryIdResponse,
  AlsintanCategoryResponse,
  AlsintanResponse,
} from "./interface";

//SECTION - Get All Alsintan
const getAlsintan = async (
  query?: string
): Promise<ApiResponse<DataPaginate<AlsintanResponse>>> => {
  return await fetcher(query ? `master/alsintan?${query}` : `master/alsintan`);
};

export const useGetAlsintan = (query?: string) => {
  return useQuery<ApiResponse<DataPaginate<AlsintanResponse>>, Error>({
    queryKey: ["useGetAlsintan", query],
    queryFn: () => getAlsintan(query),
    keepPreviousData: true,
    refetchIntervalInBackground: true,
  });
};

const getAlsintanByCategoryId = async (
  id: number,
  query?: string
): Promise<ApiResponse<DataArray<AlsintanByCategoryIdResponse>>> => {
  return await fetcher(
    query
      ? `master/alsintan/category/${id}?${query}`
      : `master/alsintan/category/${id}`
  );
};

export const useGetAlsintanByCategoryId = (id: number, query?: string) => {
  return useQuery<ApiResponse<DataArray<AlsintanByCategoryIdResponse>>, Error>({
    queryKey: ["useGetAlsintanByCategoryId", id, query],
    queryFn: () => getAlsintanByCategoryId(id, query),
    keepPreviousData: true,
    refetchIntervalInBackground: true,
    enabled: !!id,
  });
};

const getAlsintanCategory = async (
  query?: string
): Promise<ApiResponse<DataPaginate<AlsintanCategoryResponse>>> => {
  return await fetcher(
    query ? `master/alsintan-category?${query}` : `master/alsintan-category`
  );
};

export const useGetAlsintanCategory = (query?: string) => {
  return useQuery<ApiResponse<DataPaginate<AlsintanCategoryResponse>>, Error>({
    queryKey: ["useGetAlsintanCategory", query],
    queryFn: () => getAlsintanCategory(query),
    keepPreviousData: true,
    refetchIntervalInBackground: true,
  });
};
